export default __webpack_public_path__ + "static/media/b11.8f9ef132.png";